"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _popover = _interopRequireDefault(require("@paprika/popover"));

var _l10n = require("@paprika/l10n");

var _helpers = require("@paprika/helpers");

var _LinkTooltipContentPropsCollector = _interopRequireDefault(require("./LinkTooltipContentPropsCollector"));

var _context = _interopRequireDefault(require("../../context"));

var _constants = require("../../constants");

var sc = _interopRequireWildcard(require("./Link.styles"));

var _excluded = ["children", "hasOnlyOneChild", "href", "as"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var truncate = function truncate(str) {
  return str.length > _constants.MAXIMUM_NUM_OF_CHARACTER ? "".concat(str.substring(0, _constants.MAXIMUM_NUM_OF_CHARACTER), "...") : str;
};

function isString(item) {
  return typeof item === "string" || item instanceof String;
}

function Link(props) {
  var children = props.children,
      hasOnlyOneChild = props.hasOnlyOneChild,
      href = props.href,
      as = props.as,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var I18n = (0, _l10n.useI18n)();

  var isDark = _react["default"].useContext(_context["default"]);

  var _extractChildren = (0, _helpers.extractChildren)(children, ["Breadcrumbs.Link.Tooltip"]),
      _extractChildren$chil = (0, _slicedToArray2["default"])(_extractChildren.children, 1),
      extractedChildren = _extractChildren$chil[0];

  var TooltipProps = (0, _helpers.extractChildrenProps)(children, _LinkTooltipContentPropsCollector["default"]);

  var shouldTruncate = isString(extractedChildren) && extractedChildren.length > _constants.MAXIMUM_NUM_OF_CHARACTER;

  var isUsingDefaultLinkComponent = !as;
  var commonComponentProps = {
    "data-pka-anchor": "breadcrumbs.link",
    as: isUsingDefaultLinkComponent ? _button["default"].Link : as,
    href: href || undefined,
    isDark: isDark
  };

  if (isUsingDefaultLinkComponent) {
    commonComponentProps.kind = _button["default"].types.kind.MINOR;
  }

  function renderBackIcon() {
    return hasOnlyOneChild ? /*#__PURE__*/_react["default"].createElement(sc.BackIcon, {
      "aria-label": I18n.t("breadcrumbs.aria_back_to"),
      "data-pka-anchor": "breadcrumbs.back-icon"
    }) : null;
  }

  return /*#__PURE__*/_react["default"].createElement(sc.ListItem, {
    "data-pka-anchor": "breadcrumbs.list-item",
    isUsingDefaultLinkComponent: isUsingDefaultLinkComponent
  }, shouldTruncate ? /*#__PURE__*/_react["default"].createElement(_popover["default"], {
    isDark: true,
    isEager: true
  }, /*#__PURE__*/_react["default"].createElement(_popover["default"].Trigger, null, function (handler, a11yAttributes) {
    return /*#__PURE__*/_react["default"].createElement(sc.Link, (0, _extends2["default"])({}, commonComponentProps, {
      onMouseOver: handler,
      onMouseOut: handler,
      onFocus: handler,
      onBlur: handler,
      tabIndex: isUsingDefaultLinkComponent ? undefined : 0
    }, a11yAttributes, moreProps), renderBackIcon(), truncate(extractedChildren));
  }), /*#__PURE__*/_react["default"].createElement(_popover["default"].Content, TooltipProps, /*#__PURE__*/_react["default"].createElement(_popover["default"].Card, null, extractedChildren)), /*#__PURE__*/_react["default"].createElement(_popover["default"].Tip, null)) : /*#__PURE__*/_react["default"].createElement(sc.Link, (0, _extends2["default"])({}, commonComponentProps, moreProps), renderBackIcon(), extractedChildren));
}

var propTypes = {
  children: _propTypes["default"].node,

  /** Render as another component instead of Button.Link. */
  as: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].elementType]),
  hasOnlyOneChild: _propTypes["default"].bool,

  /** Url for the link. */
  href: _propTypes["default"].string
};
var defaultProps = {
  children: null,
  as: null,
  hasOnlyOneChild: false,
  href: null
};
Link.displayName = "Breadcrumbs.Link";
Link.Tooltip = _LinkTooltipContentPropsCollector["default"];
Link.propTypes = propTypes;
Link.defaultProps = defaultProps;
var _default = Link;
exports["default"] = _default;
//# sourceMappingURL=Link.js.map